module.exports = __webpack_public_path__ + "static/media/stress-management.2a6901d3.png";